module.exports = __webpack_public_path__ + "static/media/ci-logo2.49f329c0.png";